/* ============================================================================
   MoveOn™ Listicle landing page — interactions (SINGAPORE fork)
   ----------------------------------------------------------------------------
   Fork of listicle-au.js for moveon-listicle-singapore.html. Same behavior,
   but the offer is the SG model: four one-time box bundles (1/2/3/6 boxes,
   S$115/205/259/499), no subscription, S$ money.
   Drives:
     • hero carousel   (6 slides, auto-advance, dot controls, reset-on-pick)
     • marquee walls   (doctor row + customer video row, cloned for a seamless loop)
     • offer gallery   (cross-fade + thumbnails)
     • bundle + plan   (live pricing across CTA, cart drawer and sticky bar)
     • cart drawer     (slide-in summary, Esc / scrim to close)
     • FAQ + ingredient accordions (single-open)
     • review wall     (3 columns auto-scrolling at different speeds)
     • generations chart (bars grow when the block scrolls in)
     • sticky add-to-cart bar (reveals past 620px)
     • recent activity toast (bottom left, shuffled, no repeat within a cycle)
     • all [data-pro] videos (force muted + looping, never unmutable)
   ============================================================================ */
(function () {
  'use strict';

  var AUTOPLAY_MS = 4000;      // comp prop: autoplaySeconds = 4
  var SHOW_STICKY = true;      // comp prop: showStickyBar = true
  var DEFAULT_PLAN = 'once';   // SG: one-time only, no plan toggle

  // SG bundle table: four ONE-TIME box bundles, no subscription. `strike` is
  // the compare-at total (qty × the S$115 single-box price); saving = strike
  // gap + the S$9.90 shipping every bundle ships free. variant ids are the
  // LIVE fhzisg-0b.myshopify.com "Immority MoveOn" product (9720132305139),
  // prices/compare-at match the store (115/205+230/259+345/499+690).
  var BUNDLES = [
    // A box holds 16 sachets, one a day, so days == sach.
    { t: '1 box',   boxes: 1, days: 16, sach: 16, price: 115, strike: 0,   variant: 50274990194931, plan: 0 },
    { t: '2 boxes', boxes: 2, days: 32, sach: 32, price: 205, strike: 230, variant: 50274990227699, plan: 0 },
    { t: '3 boxes', boxes: 3, days: 48, sach: 48, price: 259, strike: 345, variant: 50274990260467, plan: 0 },
    { t: '6 boxes', boxes: 6, days: 96, sach: 96, price: 499, strike: 690, variant: 50274990293235, plan: 0 }
  ];


  /* Cross-sell add-on: LiveOn, the sibling sachet. Ticking it adds a SECOND
     line item next to the MoveOn bundle.
     TODO BEFORE PUBLISH — LiveOn does not exist on the SG store yet:
       1. create the LiveOn product + variant on fhzisg-0b
       2. put the real variant id in `variant` and the real SG prices in
          `price` / `strike`
     While `variant` is 0 the block shows a PLACEHOLDER badge and checkout
     silently skips the second line, so nothing can be mis-sold. */
  var ADDON = {
    title: 'LiveOn\u2122 \u00b7 Daily Cell Care',
    sub: 'MoveOn is for the joint and mobility today. LiveOn is for the whole body tomorrow, with over 100 health benefits.',
    img: 'molsg-liveon.webp',
    /* LIVE variant ids, product "Immority LiveOn: Daily Cellular Renewal"
       (9740070748403) on fhzisg-0b. LiveOn is priced identically to MoveOn. */
    variants: { 1: 50539670864115, 2: 50539670962419, 3: 50539670995187, 6: 50539671027955 }
  };

  /* Box pricing (Brandon, 2026-10-23): the order is priced ONLY on its total
     number of boxes, MoveOn and LiveOn mixed:
        1 S$115 · 2 S$205 · 3 S$259 · 4 S$339 · 5 S$419 · 6 S$499
        7 S$614 · 8 S$704 · 9 S$758 · 10 S$838 · 11 S$918 · 12 S$998
     Checkout charges it through Shopify automatic discounts "Box price · N boxes"
     on the two 1-box variants, which is why checkout always posts single boxes
     (a pack would count as ONE item). Past 12 boxes Shopify keeps the 12-box
     discount (S$382), so this does too. Keep this table and those discounts in
     step. The 11.11 discounts (25 Oct to 11 Nov) come off at checkout only. */
  var BOX_SINGLE = 115;
  var BOX_PRICE = [0, 115, 205, 259, 339, 419, 499, 614, 704, 758, 838, 918, 998];
  /* 11.11 Mix & Match (25 Oct to 11 Nov): S$22 off 3+ boxes, S$55 off 6+,
     S$110 off 12+, on top of the ladder. html.is-1111 is set by the section's
     inline script in exactly the checkout discounts' window. */
  var SALE = document.documentElement.classList.contains('is-1111');
  function saleOff(n) { return !SALE ? 0 : n >= 12 ? 110 : n >= 6 ? 55 : n >= 3 ? 22 : 0; }
  function boxPrice(n) {
    var p = n <= 12 ? BOX_PRICE[n] : BOX_SINGLE * n - (BOX_SINGLE * 12 - BOX_PRICE[12]);
    return p - saleOff(n);
  }
  /* b.base keeps the normal bundle price so the cards can strike it */
  if (SALE) BUNDLES.forEach(function (b) { b.base = b.price; b.price = boxPrice(b.boxes); });
  /* Mix & Match version (?offer=mix): pick a box total, split it between
     MoveOn and LiveOn. Price is boxPrice(total), so any split costs the same.
     1 and 2 boxes sit behind a "Just want 1 or 2 boxes?" toggle. */
  var MIX = document.documentElement.classList.contains('is-mix');
  var MIX_TIERS = [
    { n: 1,  m: 1, badge: '' },
    { n: 2,  m: 1, badge: '' },
    { n: 3,  m: 2, badge: '' },
    { n: 6,  m: 3, badge: 'Most popular' },
    { n: 12, m: 6, badge: 'Best value' }
  ];
  var mix = { tier: 3, m: 3, small: false };   // default: 6 boxes, 3 + 3
  function mixTotal() { return MIX_TIERS[mix.tier].n; }
  function mixSplitText(m, l) {
    return m && l ? m + ' MoveOn + ' + l + ' LiveOn' : m ? m + ' MoveOn' : l + ' LiveOn';
  }
  function wasHtml(was, now, money) {    // '~~S$259~~ ' when 11.11 lowers it
    return was > now ? '<s class="mo-s11was">' + money(was) + '</s> ' : '';
  }

  function moveonBundle() { return BUNDLES[state.bundle]; }
  function liveonBundle(n) {
    for (var i = 0; i < BUNDLES.length; i++) if (BUNDLES[i].boxes === n) return BUNDLES[i];
    return BUNDLES[0];
  }
  function liveonNormal(n) {                  // LiveOn's own compare-at figure
    var b = liveonBundle(n);
    return b.strike || b.price;
  }
  function addonTier() {
    var mo = moveonBundle();
    var b = liveonBundle(state.addonBoxes);   // LiveOn costs what MoveOn costs
    var matched = mo.boxes === b.boxes;
    var combo = boxPrice(mo.boxes + b.boxes);
    var adds = combo - mo.price;              // what ticking LiveOn actually adds
    var alone = liveonNormal(b.boxes);
    return {
      boxes: b.boxes, sach: b.sach,
      price: adds,
      strike: adds < alone ? alone : 0,       // only strike when it really is less
      combo: combo, moveon: mo.price, matched: matched,
      variant: ADDON.variants[b.boxes] || 0
    };
  }


  var state = { slide: 0, gal: 0, bundle: 2, plan: DEFAULT_PLAN, bar: false, cartOpen: false, cart: null, addon: false, addonBoxes: 3 };

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function fmt(n) { return 'S$' + (Number.isInteger(n) ? String(n) : n.toFixed(2)).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function savingOf(b) { return (b.strike ? b.strike - b.price : 0) + 9.9; }
  function setText(sel, txt) { $$(sel).forEach(function (el) { el.textContent = txt; }); }

  /* ---------------------------------------------------------------- hero -- */
  var heroTrack = $('[data-hero-track]');
  var heroDots = $$('[data-hero-dot]');
  var heroCount = heroTrack ? heroTrack.children.length : 0;
  var heroTimer = null;

  function renderHero() {
    if (!heroTrack) return;
    heroTrack.style.transform = 'translateX(-' + (state.slide * 100) + '%)';
    heroDots.forEach(function (d, i) { d.classList.toggle('is-active', i === state.slide); });
    var sh = $('[data-sale-hero]');           // 11.11 poster sits over slide 1
    if (sh) sh.classList.toggle('is-off', state.slide !== 0);
  }

  function startHeroTimer() {
    if (heroTimer) clearInterval(heroTimer);
    if (!heroCount || reduceMotion) return;
    heroTimer = setInterval(function () {
      state.slide = (state.slide + 1) % heroCount;
      renderHero();
    }, AUTOPLAY_MS);
  }

  heroDots.forEach(function (dot, i) {
    dot.addEventListener('click', function () {
      state.slide = i;
      renderHero();
      startHeroTimer();          // picking a dot restarts the clock, as in the comp
    });
  });

  /* ------------------------------------------------------- marquee walls -- */
  // Drives both the doctor row and the customer-video row. Each authors ONE
  // group; the loop needs two identical halves for translateX(-50%) to land on
  // the seam, so the clone is made here rather than asking anyone to keep a
  // duplicate block in sync by hand. data-wall-pace is seconds per card, which
  // holds the same reading speed whether the row has 8 cards or 20.
  //
  // This runs before the [data-pro] video pass below on purpose: the cloned
  // clips have to be in the DOM by then to get the same muted/lazy treatment.
  function rollWall(root) {
    if (reduceMotion) return;
    var group = $('[data-wall-group]', root);
    var rail = $('[data-wall-track]', root);
    if (!group || !rail || !group.children.length) return;

    var clone = group.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    // the copy is decorative: keep it off the accessibility tree entirely
    $$('video, img', clone).forEach(function (el) { el.removeAttribute('aria-label'); el.alt = ''; });

    rail.appendChild(clone);
    rail.style.animationDuration = (group.children.length * (Number(root.getAttribute('data-wall-pace')) || 5)) + 's';
    root.classList.add('is-rolling');
  }

  $$('[data-wall]').forEach(rollWall);

  /* ----------------------------------------------- recent activity toast -- */
  // Bottom-left social proof. Every entry is a Singapore customer, and the queue
  // is shuffled and drained before it refills, so nobody sees the same person
  // twice in a cycle (and never the same one twice in a row across cycles).
  //
  // REPLACE THESE WITH REAL ORDERS / REAL REVIEWS before this goes live.
  var PROOF = [
    { line: '<b>Mdm Tan</b> ordered the 3-box bundle', meta: 'Bedok · 4 minutes ago' },
    { line: '<b>Siti R.</b> ordered the 6-box bundle', meta: 'Tampines · 11 minutes ago' },
    { line: '&ldquo;My morning stiffness is gone.&rdquo;', meta: '★★★★★ Mr Lim · Ang Mo Kio' },
    { line: '<b>Rajesh K.</b> ordered the 2-box bundle', meta: 'Serangoon · 18 minutes ago' },
    { line: '&ldquo;Stairs are much easier now.&rdquo;', meta: '★★★★★ Grace T. · Punggol' },
    { line: '<b>Mdm Wong</b> ordered the 3-box bundle', meta: 'Toa Payoh · 26 minutes ago' },
    { line: '&ldquo;No more aching knees at night.&rdquo;', meta: '★★★★★ Faridah B. · Woodlands' },
    { line: '<b>Mr Chua</b> ordered the 6-box bundle', meta: 'Jurong West · 34 minutes ago' },
    { line: '<b>Angela N.</b> ordered the 3-box bundle', meta: 'Clementi · 41 minutes ago' },
    { line: '&ldquo;I can kneel in the garden again.&rdquo;', meta: '★★★★★ Kumar S. · Yishun' },
    { line: '<b>Mdm Goh</b> ordered the 2-box bundle', meta: 'Hougang · 53 minutes ago' },
    { line: '&ldquo;Worth every cent.&rdquo;', meta: '★★★★★ Mr Tay · Bishan' },
    { line: '<b>Nurul A.</b> ordered the 3-box bundle', meta: 'Pasir Ris · 1 hour ago' },
    { line: '<b>Mr Ong</b> ordered the 3-box bundle', meta: 'Sengkang · 1 hour ago' },
    { line: '<b>Mdm Lee</b> ordered the 3-box bundle', meta: 'Bukit Batok · 1 hour ago' },
    { line: '&ldquo;I stopped dreading the stairs.&rdquo;', meta: '★★★★★ Daniel S. · Queenstown' },
    { line: '<b>Mr Rahman</b> ordered the 6-box bundle', meta: 'Bukit Panjang · 2 hours ago' },
    { line: '<b>Mdm Chia</b> ordered the 2-box bundle', meta: 'Kallang · 2 hours ago' },
    { line: '&ldquo;My hips feel looser already.&rdquo;', meta: '★★★★★ Priya D. · Choa Chu Kang' },
    { line: '<b>Mr Teo</b> ordered the 3-box bundle', meta: 'Marine Parade · 2 hours ago' },
    { line: '<b>Jasmine K.</b> ordered the 3-box bundle', meta: 'Bukit Merah · 3 hours ago' },
    { line: '&ldquo;Gardening again after two years.&rdquo;', meta: '★★★★★ Mdm Koh · Jurong East' },
    { line: '<b>Mr Iskandar</b> ordered the 3-box bundle', meta: 'Geylang · 3 hours ago' },
    { line: '<b>Rebecca L.</b> ordered the 6-box bundle', meta: 'Novena · 4 hours ago' },
    { line: '&ldquo;Less stiff when I wake up.&rdquo;', meta: '★★★★★ Mdm Ng · Bukit Timah' }
  ];

  var PROOF_VISIBLE = 4200;    // how long a card stays on screen
  var PROOF_MIN = 5000;        // pop-to-pop gap, per the brief: every 5-10s
  var PROOF_MAX = 10000;

  var proof = $('[data-proof]');
  var proofQueue = [];
  var proofLast = null;
  var proofTimer = null;
  var proofStopped = false;

  function refillProof() {
    proofQueue = PROOF.slice();
    for (var i = proofQueue.length - 1; i > 0; i--) {   // Fisher-Yates
      var j = Math.floor(Math.random() * (i + 1));
      var t = proofQueue[i]; proofQueue[i] = proofQueue[j]; proofQueue[j] = t;
    }
    // a fresh cycle must not open with whoever just closed the previous one
    if (proofLast && proofQueue[0] === proofLast && proofQueue.length > 1) {
      proofQueue.push(proofQueue.shift());
    }
  }

  function hideProof() {
    if (!proof) return;
    proof.classList.remove('is-in');
    setTimeout(function () { if (!proof.classList.contains('is-in')) proof.hidden = true; }, 420);
  }

  function showProof() {
    if (proofStopped || !proof) return;

    // never talk over an open drawer or the story lightbox
    var busy = (cart && cart.classList.contains('is-open')) || (ugcModal && !ugcModal.hidden);
    if (busy) { proofTimer = setTimeout(showProof, 3000); return; }

    if (!proofQueue.length) refillProof();
    var item = proofQueue.shift();
    proofLast = item;

    var line = $('[data-proof-line]', proof);
    var meta = $('[data-proof-meta]', proof);
    if (line) line.innerHTML = item.line;      // authored above, not user input
    if (meta) meta.textContent = item.meta;

    proof.hidden = false;
    requestAnimationFrame(function () { proof.classList.add('is-in'); });

    setTimeout(hideProof, PROOF_VISIBLE);
    var gap = PROOF_MIN + Math.random() * (PROOF_MAX - PROOF_MIN);
    proofTimer = setTimeout(showProof, gap);
  }

  if (proof) {
    var close = $('[data-proof-close]', proof);
    if (close) {
      close.addEventListener('click', function () {
        proofStopped = true;
        if (proofTimer) clearTimeout(proofTimer);
        hideProof();
      });
    }
    proofTimer = setTimeout(showProof, 6000);   // let the page settle first
  }

  /* ------------------------------------------------- customer story modal -- */
  // The clips in the wall are muted for good — [data-pro] enforces that below.
  // Sound is opt-in: clicking a card opens this lightbox, which is the only
  // player on the page with audio and controls, and it plays the full story
  // alongside the clip. Delegated from the wall so the cloned half works too.
  var ugcModal = $('[data-ugcmodal]');
  var ugcWall = $('.mo-ugcwall');
  var ugcVid = ugcModal && $('[data-ugcmodal-vid]', ugcModal);
  var ugcLastFocus = null;

  function closeStory() {
    if (!ugcModal || ugcModal.hidden) return;
    if (ugcVid) { ugcVid.pause(); ugcVid.removeAttribute('src'); ugcVid.load(); }
    ugcModal.hidden = true;
    document.documentElement.style.overflow = '';
    if (ugcLastFocus && ugcLastFocus.focus) ugcLastFocus.focus();
    ugcLastFocus = null;
  }

  function openStory(btn) {
    if (!ugcModal || !ugcVid) return;
    var card = btn.closest('.mo-ugccard');
    var tpl = card && $('[data-ugc-story]', card);
    var name = btn.getAttribute('data-ugc-name') || '';

    setText('[data-ugcmodal-name]', name);
    var body = $('[data-ugcmodal-body]', ugcModal);
    if (body) {
      body.innerHTML = '';
      if (tpl) body.appendChild(tpl.content.cloneNode(true));
    }

    ugcVid.poster = btn.getAttribute('data-ugc-poster') || '';
    ugcVid.src = btn.getAttribute('data-ugc-src') || '';
    ugcVid.muted = false;          // the whole point of the click
    ugcVid.currentTime = 0;

    ugcLastFocus = btn;
    ugcModal.hidden = false;
    document.documentElement.style.overflow = 'hidden';

    var p = ugcVid.play();
    if (p && p.catch) p.catch(function () {});   // a blocked autoplay still shows controls
    var close = $('[data-ugc-close]', ugcModal.querySelector('.mo-ugcmodal-panel'));
    if (close) close.focus();
  }

  if (ugcWall && ugcModal) {
    ugcWall.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ugc-open]');
      if (btn) openStory(btn);
    });
    $$('[data-ugc-close]', ugcModal).forEach(function (el) {
      el.addEventListener('click', closeStory);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeStory();
    });
  }

  /* ------------------------------------------------------------- gallery -- */
  var galSlides = $$('[data-gal-slide]');
  var galThumbs = $$('[data-gal-thumb]');

  function renderGallery() {
    galSlides.forEach(function (img, i) { img.classList.toggle('is-active', i === state.gal); });
    galThumbs.forEach(function (b, i) {
      b.classList.toggle('is-active', i === state.gal);
      b.setAttribute('aria-current', i === state.gal ? 'true' : 'false');
    });
  }

  galThumbs.forEach(function (btn, i) {
    btn.addEventListener('click', function () { state.gal = i; renderGallery(); });
  });

  /* ------------------------------------------------- bundle / plan / cart -- */
  var offerRoot = $('[data-offer]');
  var bundleBtns = $$('[data-bundle]');
  var cart = $('[data-cart]');


  /* ------------------------------------------------------------- upsell -- */
  /* There are TWO cards on the page now: one under the checkout button, one
     inside the cart drawer. They are the same offer, so everything is written
     into every card and scoped per card — no card can drift out of sync.
     Only the buy-box card carries the self-check and the sum line; by the time
     the drawer opens the customer has already committed, so that copy is cut. */
  function syncUpsell() {
    var t = addonTier();
    var save = t.strike ? t.strike - t.price : 0;

    $$('[data-upsell]').forEach(function (box) {
      function put(sel, txt) { var el = $(sel, box); if (el) el.textContent = txt; }
      put('[data-upsell-title]', ADDON.title);
      var subEl = $('[data-upsell-sub]', box);
      if (subEl) {
        subEl.textContent = ADDON.sub + ' ';
        var b = document.createElement('b');
        b.textContent = state.addon
          ? 'This is an optional extra. Untick the box to take it off your order.'
          : 'This is an optional extra. Tick the box to add it to your order.';
        subEl.appendChild(b);
      }
      put('[data-upsell-now]', fmt(t.price));

      var was = $('[data-upsell-was]', box);
      if (was) { was.textContent = t.strike ? fmt(t.strike) : ''; was.style.display = t.strike ? '' : 'none'; }

      // derived, never typed: a price edit can't leave a stale saving behind
      var note = $('[data-upsell-note]', box);
      if (note) { note.textContent = save > 0 ? 'Save ' + fmt(save) : ''; note.style.display = save > 0 ? '' : 'none'; }

      $$('[data-upsell-box]', box).forEach(function (b) {
        b.classList.toggle('is-on', Number(b.getAttribute('data-upsell-box')) === state.addonBoxes);
      });



      var eb = $('[data-upsell-eyebrow-text]', box);
      if (eb) eb.textContent = state.addon ? 'Added to your order' : 'Often bought together';
      box.classList.toggle('is-on', state.addon);
      var input = $('[data-upsell-input]', box);
      if (input) input.checked = state.addon;
    });

    /* The visible chip is a marketing badge now, so the "LiveOn has no real
       variant yet" state warns here instead of on the card. Checkout still
       skips the second line while these are 0, so nothing can be mis-sold. */
    if (!t.variant && !ADDON.warned) {
      ADDON.warned = true;
      if (window.console) console.warn('[MoveOn SG] LiveOn upsell has no variant ids yet - the add-on will NOT be added at checkout.');
    }

  }

  function setAddon(on) {
    state.addon = !!on;
    if (state.cart) { state.cart.addon = state.addon; syncCart(); }
    renderPricing();
  }



  /* change, not click: a label click fires click twice (label + synthesized
     input) which would toggle straight back to where it started. */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var pill = e.target.closest('[data-upsell-box]');
    if (pill) {
      state.addonBoxes = Number(pill.getAttribute('data-upsell-box'));
      if (!state.addon) { setAddon(true); return; }   // picking a size means they want it
      if (state.cart) syncCart();
      renderPricing();
      return;
    }
    if (e.target.closest('[data-upsell-toggle]')) setAddon(!state.addon);
  });

  document.addEventListener('change', function (e) {
    if (!e.target || !e.target.matches) return;
    if (e.target.matches('[data-upsell-input]')) setAddon(e.target.checked);
  });

  var LO_BENEFITS = {"Sugar damage": ["Stops sugar sticking to your proteins in the first place", "Helps bring down A1C, your three-month blood sugar number", "Flattens the blood sugar spike after a meal", "Helps your body hold on to GLP-1, the fullness hormone", "Helps your gut release more GLP-1", "Helps your body respond to insulin properly again", "Helps lower fasting blood sugar", "Blocks sugar damage in skin, kidneys and blood vessels", "Clears the wear left behind when glucose oxidises", "Lowers fructosamine, the short-term sugar damage marker"], "Antioxidant defence": ["Puts back SOD, the antioxidant your body makes itself", "Lowers the standard lab markers of oxidative stress", "Tops up glutathione, your cells' main internal antioxidant", "Delivers CoQ10 for cell energy and defence", "Protects your DNA from oxidative damage", "Protects the membranes around your cells from going rancid", "Protects the mitochondria that make your energy", "Covers both kinds of antioxidant defence at once", "Slows the build-up of worn-out cells", "Packs a very high antioxidant score into one 20 ml sachet"], "Skin": ["Helps you build new collagen", "Blocks the enzymes that chew up collagen and elastin", "Stops sugar stiffening the collagen you already have", "Softens the look of wrinkles and fine lines", "Helps skin hold on to moisture", "Improves skin firmness and elasticity", "Helps skin keep its shape instead of sagging", "Protects skin from sun-driven ageing", "Evens out dark patches and uneven tone", "Helps skin cells regenerate", "Strengthens skin's own defences", "Calms redness and reactive skin", "Supports wound healing and repair"], "Heart and arteries": ["Lowers oxidised LDL, the harmful form of cholesterol", "Keeps the lining of your blood vessels healthy", "Supports healthy blood pressure", "Keeps blood from clotting more than it should", "Improves HDL and your overall cholesterol picture", "Keeps arteries springy instead of stiff", "Lowers the risk of plaque building up in arteries", "Improves circulation to hands, feet and skin", "Helps lower triglycerides", "Stops sugar damage collecting in your blood vessel walls"], "Brain": ["Supports memory and thinking", "Protects brain cells from oxidative damage", "Calms inflammation in the brain", "Supports brain recovery after a knock or injury", "Sharpens focus, clarity and how quickly you think", "Supports BDNF, the growth factor that keeps the brain adaptable", "Lowers the protein build-up linked to Alzheimer's risk", "Stops sugar damage collecting in brain cells", "Slows age-related decline in thinking", "Protects the barrier that shields your brain"], "Inflammation": ["Turns down NF-kB, the master switch for inflammation", "Lowers COX-2, one of the main inflammation pathways", "Lowers the inflammatory messengers in your blood", "Lowers CRP, the blood test doctors use for inflammation", "Eases joint inflammation and cartilage wear", "Calms inflammation in the gut lining", "Blocks the 5-LOX inflammation pathway", "Quiets the NLRP3 inflammasome", "Lowers the low-grade inflammation that builds with age", "Eases inflammation-driven aches"], "Longevity": ["Switches on SIRT1, your repair gene, 15x more than resveratrol", "Activates AMPK, your cells' energy regulator", "Supports autophagy, your cells' self-cleaning", "Limits worn-out cells that stop pulling their weight", "Supports NAD+ through SIRT1", "Protects telomeres, the caps on your DNA", "Blocks the AGE-RAGE cascade that drives tissue damage", "Keeps growth signalling in balance", "Supports healthy gene expression"], "Metabolism": ["Improves how your body handles fats", "Helps reduce fat stored around the organs", "Supports a healthier body composition", "Helps you build more and better mitochondria", "Lowers metabolic syndrome risk markers", "Supports fat burning"], "Eyes": ["Lowers macular degeneration risk", "Protects the retina from oxidative damage", "Protects the lens from the sugar damage behind cataracts", "Protects eyes from UV and blue light", "Supports sharp vision over the long run"], "Immunity": ["Supports your first-line immune defences", "Slows the immune decline that comes with age", "Supports natural killer cell activity", "Protects immune cells from oxidative stress", "Supports antiviral defences"], "Gut": ["Feeds a more diverse gut microbiome", "Tightens up a leaky gut lining", "Lowers oxidative stress in gut tissue", "Eases digestive discomfort", "Supports regularity"], "Liver": ["Supports both phases of liver detox", "Improves fatty liver markers", "Protects liver cells from oxidative damage"], "Kidneys, hair and nails": ["Protects kidney tissue from sugar damage", "Protects kidney cells from oxidative stress", "Supports stronger hair with less breakage", "Strengthens nails and reduces brittleness"]};

  /* The 13 groups double as filters. Tapping one lists that group's benefits in
     a single panel with its own scroll, so the sheet never grows no matter how
     many are opened — the alternative, 13 stacked accordions, added ~1,600px. */
  function renderBenefits(cat) {
    var panel = $('[data-lo-blist]');
    if (!panel) return;
    var groups = cat ? [cat] : Object.keys(LO_BENEFITS);
    var html = groups.map(function (g) {
      var rows = LO_BENEFITS[g].map(function (b) { return '<li>' + b + '</li>'; }).join('');
      return (cat ? '' : '<h4>' + g + '</h4>') + '<ol>' + rows + '</ol>';
    }).join('');
    panel.innerHTML = html;
    panel.hidden = false;
    panel.scrollTop = 0;
  }
  function setBenefitFilter(cat, allBtn) {
    var panel = $('[data-lo-blist]');
    var already = panel && !panel.hidden && panel.getAttribute('data-showing') === (cat || '*');
    $$('[data-lo-cat], [data-lo-all]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); b.classList.remove('is-on'); });
    if (already) { panel.hidden = true; panel.removeAttribute('data-showing'); return; }
    renderBenefits(cat);
    panel.setAttribute('data-showing', cat || '*');
    var btn = cat ? $('[data-lo-cat="' + cat + '"]') : allBtn;
    if (btn) { btn.setAttribute('aria-pressed', 'true'); btn.classList.add('is-on'); }
  }
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var chip = e.target.closest('[data-lo-cat]');
    if (chip) { setBenefitFilter(chip.getAttribute('data-lo-cat')); return; }
    var all = e.target.closest('[data-lo-all]');
    if (all) { setBenefitFilter(null, all); return; }
  });


  /* The verdict under the checklist. It gets warmer the more boxes are ticked,
     and it stays honest at one tick: a single reason is not a reason to upsell
     someone, so that line still points them back to MoveOn alone. */
  var LO_VERDICT = [
    null,
    { lvl: 1, txt: '\ud83d\ude42 Worth a look. MoveOn on its own will still take care of the joint.' },
    { lvl: 1, txt: '\ud83d\udc4d LiveOn is starting to earn its place in your order.' },
    { lvl: 2, txt: '\ud83d\udcaa LiveOn is doing real work for someone in your position.' },
    { lvl: 3, txt: '\ud83d\udd25 This is exactly who LiveOn was built for.' },
    { lvl: 3, txt: '\u2b50 Adding LiveOn is the sensible call here.' },
    { lvl: 4, txt: '\ud83d\ude80 You would feel this one right across the board.' },
    { lvl: 4, txt: '\ud83d\ude80 If anyone should be taking LiveOn alongside MoveOn, it is you.' }
  ];
  function syncVerdict() {
    var out = $('[data-lo-verdict]');
    if (!out) return;
    var n = $$('[data-lo-check]').filter(function (i) { return i.checked; }).length;
    /* the last item is the payoff one — wanting the years ahead is buy-in to the
       whole idea, so it jumps straight to the strongest verdict on its own */
    var key = $('[data-lo-key]');
    if (key && key.checked) n = LO_VERDICT.length - 1;
    var v = LO_VERDICT[Math.min(n, LO_VERDICT.length - 1)];
    out.hidden = !v;
    if (!v) return;
    out.textContent = v.txt;
    out.className = 'mo-lo-verdict is-lvl' + v.lvl;
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-lo-check]')) syncVerdict();
  });

  /* ------------------------------------------------ LiveOn explainer -- */
  var lo = $('[data-lo]');
  function setLo(open) {
    if (!lo) return;
    lo.classList.toggle('is-open', open);
    lo.setAttribute('aria-hidden', open ? 'false' : 'true');
    // the cart drawer already owns the scroll lock when it is up
    if (!state.cartOpen) document.documentElement.style.overflow = open ? 'hidden' : '';
    if (open) { var x = $('[data-lo-close]', lo); if (x) x.focus(); }
  }
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (e.target.closest('[data-upsell-more]')) { setLo(true); return; }
    if (MIX && e.target.closest('[data-lo-add], [data-lo-decline]')) {
      mixLiveOn(!!e.target.closest('[data-lo-add]')); setLo(false); return;
    }
    if (e.target.closest('[data-lo-add]')) { setAddon(true); setLo(false); return; }
    if (e.target.closest('[data-lo-decline]')) { setAddon(false); setLo(false); return; }
    if (e.target.closest('[data-lo-close]')) { setLo(false); return; }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && lo && lo.classList.contains('is-open')) setLo(false);
  });
  /* ----------------------------------------------------------- /upsell -- */

  function renderPricing() {
    if (MIX) { syncMix(); return; }
    var B = BUNDLES[state.bundle];
    var now = B.price;

    bundleBtns.forEach(function (btn, i) {
      var b = BUNDLES[i];
      btn.classList.toggle('is-selected', i === state.bundle);
      btn.setAttribute('aria-pressed', i === state.bundle ? 'true' : 'false');
      var was = $('[data-b-was]', btn);
      var nowEl = $('[data-b-now]', btn);
      var save = $('[data-b-save]', btn);
      var sub = $('[data-b-sub]', btn);
      var unit = $('[data-b-unit]', btn);

      // The headline figure is the PER BOX price, so bundles compare like for
      // like against the single box. The order total moves to the sub line, and
      // the struck-through figure is the single-box price per box (never the
      // bundle total, which would make the saving look bigger than it is).
      var perBox = b.price / b.boxes;
      var perBoxWas = b.strike ? b.strike / b.boxes : 0;

      if (was) { was.textContent = perBoxWas ? fmt(perBoxWas) : ''; was.style.display = perBoxWas ? 'block' : 'none'; }
      if (nowEl) nowEl.textContent = fmt(perBox);
      if (unit) unit.textContent = 'per box';
      // The total is what actually gets charged, so it is not left as grey
      // small print next to the sachet count — it gets its own weight.
      if (sub) {
        sub.innerHTML = b.sach + ' sachets · ' + wasHtml(b.base, b.price, fmt);
        var tot = document.createElement('b');
        tot.className = 'mo-btotal';
        tot.textContent = fmt(b.price) + ' total';
        sub.appendChild(tot);
        if (b.base > b.price) sub.insertAdjacentHTML('beforeend',
          ' <span class="mo-s11extra">11.11 extra &minus;' + fmt(b.base - b.price) + '</span>');
      }
      // derived, never typed: a price edit can't leave a stale discount badge
      var pct = b.strike ? Math.round((b.strike - b.price) / b.strike * 100) : 0;
      if (save) { save.textContent = pct ? 'Save ' + pct + '%' : ''; save.style.display = pct ? '' : 'none'; }
    });

    var add = state.addon ? addonTier() : null;
    var ctaBoxes = B.boxes + (add ? add.boxes : 0), ctaNow = add ? add.combo : now;
    var ctaEl = $('[data-cta-price]');
    if (ctaEl) ctaEl.innerHTML = wasHtml(boxPrice(ctaBoxes) + saleOff(ctaBoxes), ctaNow, fmt) + fmt(ctaNow);
    setText('[data-bar-bundle]', B.t + (add ? ' + LiveOn' : ''));

    /* the sum is spelled out only when there are two things to add up.
       It names the box counts and the saving against BOTH normal prices, so
       the total is never just a number the customer has to take on trust. */
    var sum = $('[data-sumline]');
    if (sum) {
      sum.hidden = !add;
      if (add) {
        setText('[data-sum-a-label]', 'MoveOn \u00d7' + B.boxes);
        setText('[data-sum-b-label]', 'LiveOn \u00d7' + add.boxes);
        setText('[data-sum-total]', fmt(add.combo));
        var normal = (B.strike || B.price) + liveonNormal(add.boxes);
        var saved = normal - add.combo;
        setText('[data-sum-save]', saved > 0 ? 'Save ' + fmt(saved) : '');
      }
    }
    syncUpsell();

  }

  /* ---------------------------------------------------- mix & match -- */
  function buildMix() {
    var box = $('[data-mix-tiers]');
    if (!box) return;
    var loAdd = $('[data-lo-add]');           // the sheet's button speaks "mix" here
    if (loAdd) loAdd.textContent = 'Add LiveOn to my mix';
    var card = function (t, i) {
      var badge = t.badge ? '<span class="mo-badge ' + (t.n === 12 ? 'mo-badge--best' : 'mo-badge--popular') +
        '" style="position:absolute;top:-9px;right:16px;font-size:11px;padding:3px 10px">' + t.badge + '</span>' : '';
      return '<button type="button" class="mo-pick" data-mix-tier="' + i + '"' + (t.n < 3 ? ' data-mix-small' : '') +
        ' aria-pressed="false" style="text-align:left;position:relative">' + badge +
        '<span class="mo-radio"></span><span style="flex:1;min-width:0">' +
        '<span style="display:flex;align-items:center;gap:8px;flex-wrap:wrap"><span style="font-family:var(--font-sans);font-weight:700;font-size:17px;color:var(--color-text)">' +
        t.n + (t.n === 1 ? ' box' : ' boxes') + '</span><span class="mo-badge mo-badge--save" data-b-save style="font-size:11px;padding:3px 9px"></span></span>' +
        '<span style="display:block;font-family:var(--font-sans);font-size:14px;color:var(--color-text-2)" data-mix-sub></span></span>' +
        '<span style="text-align:right;flex:none"><s class="mo-was" data-b-was style="font-family:var(--font-sans);font-size:13px;color:var(--color-text-2)"></s>' +
        '<b data-b-now style="font-family:var(--font-sans);font-weight:800;font-size:20px;color:var(--color-brand)"></b>' +
        '<span style="display:block;font-family:var(--font-sans);font-size:13px;line-height:1.25;color:var(--color-text-2)">a box</span></span></button>';
    };
    var deals = '', small = '';
    MIX_TIERS.forEach(function (t, i) { if (t.n < 3) small += card(t, i); else deals += card(t, i); });
    box.innerHTML = deals +
      '<button type="button" class="mo-mix-more" data-mix-more aria-expanded="false">Just want 1 or 2 boxes?</button>' + small;
  }

  /* the LiveOn sheet, opened from "More info" in the mix: Add makes sure at
     least one box is LiveOn, No thanks turns the whole mix into MoveOn */
  function mixLiveOn(want) {
    var n = mixTotal();
    if (want && n - mix.m === 0) mix.m = n - 1;   // one box moves over to LiveOn
    if (!want) mix.m = n;
    syncMix();
  }

  function syncMix() {
    var n = mixTotal(), l = n - mix.m, price = boxPrice(n), base = price + saleOff(n);
    $$('[data-mix-tier]').forEach(function (btn) {
      var i = +btn.getAttribute('data-mix-tier'), t = MIX_TIERS[i], on = i === mix.tier;
      var p = boxPrice(t.n), b = p + saleOff(t.n), single = BOX_SINGLE * t.n, tm = on ? mix.m : t.m;
      btn.classList.toggle('is-selected', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var pct = single > p ? Math.round((single - p) / single * 100) : 0;
      var sv = $('[data-b-save]', btn);
      sv.textContent = pct ? 'Save ' + pct + '%' : ''; sv.style.display = pct ? '' : 'none';
      var was = $('[data-b-was]', btn);
      was.textContent = t.n > 1 ? fmt(BOX_SINGLE) : ''; was.style.display = t.n > 1 ? 'block' : 'none';
      $('[data-b-now]', btn).textContent = fmt(p / t.n);
      $('[data-mix-sub]', btn).innerHTML = mixSplitText(tm, t.n - tm) + ' · ' + wasHtml(b, p, fmt) +
        '<b class="mo-btotal">' + fmt(p) + ' total</b>' +
        (b > p ? ' <span class="mo-s11extra">11.11 extra &minus;' + fmt(b - p) + '</span>' : '');
    });
    $$('[data-mix-small]').forEach(function (c) { c.hidden = !mix.small; });
    var more = $('[data-mix-more]');
    if (more) {
      more.textContent = mix.small ? 'Hide 1 and 2 boxes' : 'Just want 1 or 2 boxes?';
      more.setAttribute('aria-expanded', mix.small ? 'true' : 'false');
    }
    setText('[data-mix-n]', n);
    setText('[data-mix-count="mo"]', mix.m);
    setText('[data-mix-count="lo"]', l);
    $$('[data-mix-step]').forEach(function (b) {
      var who = b.getAttribute('data-mix-step'), d = +b.getAttribute('data-mix-d');
      var mine = who === 'mo' ? mix.m : l;
      b.disabled = d < 0 ? mine <= 0 : mine >= n;
    });
    var ctaEl = $('[data-cta-price]');
    if (ctaEl) ctaEl.innerHTML = wasHtml(base, price, fmt) + fmt(price);
    setText('[data-bar-bundle]', mixSplitText(mix.m, l));
  }

  document.addEventListener('click', function (e) {
    if (!MIX || !e.target || !e.target.closest) return;
    var t;
    if ((t = e.target.closest('[data-mix-step]'))) {
      var who = t.getAttribute('data-mix-step'), dd = +t.getAttribute('data-mix-d'), tot = mixTotal();
      var nm = mix.m + (who === 'mo' ? dd : -dd);
      if (nm >= 0 && nm <= tot) { mix.m = nm; syncMix(); }
      return;
    }
    if ((t = e.target.closest('[data-mix-more]'))) {
      mix.small = !mix.small;
      if (!mix.small && mixTotal() < 3) { mix.tier = 3; mix.m = MIX_TIERS[3].m; }   // back to 6 (3 + 3)
      syncMix(); return;
    }
    if ((t = e.target.closest('[data-mix-tier]'))) {
      mix.tier = +t.getAttribute('data-mix-tier'); mix.m = MIX_TIERS[mix.tier].m; syncMix();
    }
  });

  bundleBtns.forEach(function (btn, i) {
    BUNDLES[i].img = btn.getAttribute('data-bundle-img') || '';
    btn.addEventListener('click', function () {
      state.bundle = i;
      state.addonBoxes = BUNDLES[i].boxes;   // re-sync: this pick is the later one
      renderPricing();
    });
  });

  function setCart(open) {
    state.cartOpen = open;
    if (open) { syncUpsell(); syncCart(); }
    if (!cart) return;
    cart.classList.toggle('is-open', open);
    cart.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.documentElement.style.overflow = open ? 'hidden' : '';
    if (open) {
      var close = $('[data-cart-close]', cart);
      if (close) close.focus();
    }
  }

  /* AU cart drawer, ported from pdp-au.js: the drawer is front-end state that
     slides out the moment Add to cart is clicked. The real Shopify cart is only
     built when Checkout is pressed (and off Shopify that build fails silently
     and we navigate anyway). */
  var CHECK_SVG = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="var(--color-brand-2)" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="flex:none;margin-top:3px"><path d="M4 12.5l5.5 5.5L20 6.5"></path></svg>';

  function perksHtml(b) {
    var rows = [
      'Free Singapore-wide shipping <s style="color:var(--color-text-2)">S$9.90</s>',
      'Dispatched in 1 business day, tracked delivery'
    ];
    if (b.strike) rows.unshift(fmt(b.strike - b.price) + ' off versus buying single boxes');
    return rows.map(function (r) {
      return '<span style="display:flex;align-items:flex-start;gap:9px;font-family:var(--font-sans);font-size:15px;line-height:1.4;color:var(--color-text)">' + CHECK_SVG + '<span>' + r + '</span></span>';
    }).join('');
  }

  function syncCart() {
    var c = state.cart;
    if (!c) return;
    if (c.mix) {
      var mq = c.mix.m * c.qty, lq = c.mix.l * c.qty, mb = mq + lq, mCharged = boxPrice(mb);
      setText('[data-cart-bundle]', 'Mix & Match · ' + (c.mix.m + c.mix.l) + ' boxes');
      setText('[data-cart-plan]', mixSplitText(mq, lq) + (c.qty > 1 ? ' in total' : '') + ' · one-time');
      setText('[data-cart-qty]', c.qty);
      setText('[data-cart-line]', fmt(mCharged));
      setText('[data-cart-saving]', '− ' + fmt(Math.round((BOX_SINGLE * mb - mCharged + 9.9) * 100) / 100));
      setText('[data-cart-subtotal]', fmt(mCharged));
      var mPerks = $('[data-cart-perks]');
      if (mPerks) mPerks.innerHTML = perksHtml({ strike: BOX_SINGLE * mb, price: mCharged });
      var mImg = $('[data-cart-img]');
      if (mImg) mImg.style.backgroundImage = 'url(' + BUNDLES[0].img + ')';
      return;
    }
    var b = BUNDLES[c.bundle];
    setText('[data-cart-bundle]', 'MoveOn™ · ' + b.t);
    setText('[data-cart-plan]', 'One-time purchase · ' + b.days + '-day supply');
    setText('[data-cart-qty]', c.qty);
    var at = addonTier();
    var hasAddon = !!c.addon;
    var moBoxes = b.boxes * c.qty;
    var boxes = moBoxes + (hasAddon ? at.boxes : 0);
    var charged = boxPrice(boxes);            // the whole order, on its box count
    setText('[data-cart-line]', fmt(boxPrice(moBoxes)));
    ADDON.boxPrice = boxPrice(moBoxes + at.boxes) - boxPrice(moBoxes);
    ADDON.boxLabel = at.boxes + (at.boxes === 1 ? ' box' : ' boxes') + ' \u00b7 ' + at.sach + ' sachets';
    /* saving covers BOTH lines plus the free S$9.90 shipping */
    var saved = BOX_SINGLE * boxes - charged + 9.9;
    setText('[data-cart-saving]', '− ' + fmt(Math.round(saved * 100) / 100));
    setText('[data-cart-subtotal]', fmt(charged));
    var perks = $('[data-cart-perks]');
    if (perks) perks.innerHTML = perksHtml(b);
    var cartImg = $('[data-cart-img]');
    if (cartImg) cartImg.style.backgroundImage = 'url(' + b.img + ')';
  }

  /* Pressing Add to cart again keeps the same selection: one set, never a second one.
     A different selection replaces the line — the drawer renders exactly one item. */
  function addToCart() {
    if (MIX) {                                // Mix & Match: one line holding the split
      var mn = mixTotal(), ml = mn - mix.m;
      var msame = state.cart && state.cart.mix && state.cart.mix.m === mix.m && state.cart.mix.l === ml;
      if (!msame) state.cart = { mix: { m: mix.m, l: ml }, plan: 'once', qty: 1, addon: false };
      syncCart();
      setCart(true);
      return;
    }
    var same = state.cart && state.cart.bundle === state.bundle;
    if (state.cart) state.cart.addon = state.addon;
    if (!same) {
      var B = BUNDLES[state.bundle];
      state.cart = { bundle: state.bundle, plan: 'once', qty: 1, unit: B.price, addon: state.addon };
    }
    syncCart();
    setCart(true);
  }

  $$('[data-add-to-cart]').forEach(function (b) {
    b.addEventListener('click', function () { addToCart(); });
  });
  $$('[data-qty-inc]').forEach(function (b) {
    b.addEventListener('click', function () { if (state.cart) { state.cart.qty += 1; syncCart(); } });
  });
  $$('[data-qty-dec]').forEach(function (b) {
    b.addEventListener('click', function () { if (state.cart && state.cart.qty > 1) { state.cart.qty -= 1; syncCart(); } });
  });

  /* Checkout: mirror the drawer into the real Shopify cart, then hand off. */
  $$('[data-checkout]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var c = state.cart;
      if (!c) return;
      e.preventDefault();
      var B = c.mix ? BUNDLES[0] : BUNDLES[c.bundle];
      if (!B.variant) { window.location.href = a.getAttribute('href') || '#offer'; return; }
      /* single boxes only, so Shopify's box-price discounts can count them */
      var at = addonTier();
      var items = [{ id: BUNDLES[0].variant, quantity: B.boxes * c.qty }];
      if (c.addon && ADDON.variants[1]) items.push({ id: ADDON.variants[1], quantity: at.boxes });
      if (c.mix) {                            // Mix & Match: exactly the split
        items = [];
        if (c.mix.m) items.push({ id: BUNDLES[0].variant, quantity: c.mix.m * c.qty });
        if (c.mix.l) items.push({ id: ADDON.variants[1], quantity: c.mix.l * c.qty });
      }
      var post = function (url, body) {
        return fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(body || {})
        });
      };
      /* /cart/add.js is ATOMIC: if ONE variant cannot be resolved the whole add
         is rejected and the customer lands on an empty checkout. That is what
         happened while LiveOn was still a draft product. So if a two-line add
         fails, fall back to the MoveOn line on its own — an unavailable add-on
         must never take the whole order down with it. */
      post('/cart/clear.js')
        .then(function () { return post('/cart/add.js', { items: items }); })
        .then(function (res) {
          if (res && res.ok) return null;
          if (items.length > 1) return post('/cart/add.js', { items: [items[0]] });
          return null;
        })
        .catch(function () {})
        .then(function () { window.location.href = a.getAttribute('href') || '/checkout'; });
    });
  });
  $$('[data-cart-open]').forEach(function (b) { b.addEventListener('click', function () { setCart(true); }); });
  $$('[data-cart-close]').forEach(function (b) { b.addEventListener('click', function () { setCart(false); }); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && state.cartOpen) setCart(false);
  });

  /* ---------------------------------------------------------- accordions -- */
  // Single-open per group, matching the comp (faqOpen defaults to item 0,
  // the offer's ingredient accordion defaults to closed).
  $$('[data-acc]').forEach(function (group) {
    var items = $$('.mo-acc-item', group);
    items.forEach(function (item) {
      var btn = $('.mo-acc-btn', item);
      var panel = $('.mo-acc-panel', item);
      var sym = $('.mo-acc-sym', item);
      if (!btn || !panel) return;
      btn.addEventListener('click', function () {
        var willOpen = !panel.classList.contains('is-open');
        items.forEach(function (other) {
          var p = $('.mo-acc-panel', other);
          var b = $('.mo-acc-btn', other);
          var s = $('.mo-acc-sym', other);
          if (p) p.classList.remove('is-open');
          if (b) b.setAttribute('aria-expanded', 'false');
          if (s) s.textContent = '+';
        });
        if (willOpen) {
          panel.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          if (sym) sym.textContent = '−';
        }
      });
    });
  });

  /* --------------------------------------------------------- sticky bar -- */
  var stickyBar = $('[data-sticky-bar]');

  function onScroll() {
    var show = window.scrollY > 620;
    if (show === state.bar) return;
    state.bar = show;
    if (stickyBar) stickyBar.classList.toggle('is-up', show && SHOW_STICKY);
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  /* -------------------------------------------------------------- video -- */
  // Every [data-pro] clip stays muted and looping, and can never be unmuted.
  // Only the clips actually on screen are told to play: there are 16 of them, and
  // asking a browser to run 16 concurrent streams (worse inside an embedded
  // preview iframe, e.g. the Shopify theme editor) is what makes them sit frozen
  // on the poster frame. The observer keeps 2-3 playing at a time instead.
  var vids = $$('video[data-pro]');
  var onScreen = new WeakSet();

  // Save-Data / slow connection: never pull video, the poster frames carry the section.
  var conn = navigator.connection || {};
  var lowData = !!conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '');

  function tryPlay(v) {
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  // src lives in data-src, so a clip costs nothing until it is actually reached.
  // Five 480p clips is still ~11 MB, which has no business downloading during a
  // page load nobody has scrolled yet.
  function ensureSrc(v) {
    if (v.dataset.src && !v.src) {
      v.preload = 'auto';
      v.src = v.dataset.src;
    }
  }

  function forceMute() {
    vids.forEach(function (v) {
      v.muted = true; v.defaultMuted = true; v.volume = 0; v.loop = true;
      if (v.paused && onScreen.has(v) && v.src) tryPlay(v);
    });
  }

  if ('IntersectionObserver' in window && !lowData) {
    var vObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          onScreen.add(v);
          ensureSrc(v);
          v.muted = true; v.loop = true;
          tryPlay(v);
        } else {
          onScreen.delete(v);
          if (!v.paused) v.pause();
        }
      });
    }, { rootMargin: '100px 0px', threshold: 0.01 });
    // wait for load so video never competes with the content people came for
    var startObserving = function () { vids.forEach(function (v) { vObs.observe(v); }); };
    if (document.readyState === 'complete') setTimeout(startObserving, 300);
    else window.addEventListener('load', function () { setTimeout(startObserving, 300); });
  } else if (!lowData) {
    vids.forEach(function (v) { onScreen.add(v); ensureSrc(v); });
  }

  forceMute();
  document.addEventListener('volumechange', forceMute, true);
  document.addEventListener('pause', forceMute, true);
  setInterval(forceMute, 3000);
  // an embedded preview can start hidden; re-assert when it becomes visible
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) forceMute();
  });

  /* -------------------------------------------------------- review wall -- */
  function startReviewWall() {
    var cols = $$('.mo-vcol');
    if (!cols.length || reduceMotion) return;
    var wall = $('.mo-vwall');
    var paused = false;
    var holdTimer = null;

    function hold() { paused = true; if (holdTimer) clearTimeout(holdTimer); }
    function release(ms) {
      if (holdTimer) clearTimeout(holdTimer);
      holdTimer = setTimeout(function () { paused = false; }, ms);
    }

    if (wall) {
      wall.addEventListener('pointerenter', hold);
      wall.addEventListener('pointerleave', function () { release(200); });
      wall.addEventListener('touchstart', hold, { passive: true });
      wall.addEventListener('touchend', function () { release(2500); }, { passive: true });
      wall.addEventListener('wheel', function () { hold(); release(2000); }, { passive: true });
    }

    var pos = cols.map(function (c) { return c.scrollTop; });
    cols.forEach(function (c, i) {
      c.addEventListener('scroll', function () {
        // adopt the user's position when they drag a column themselves
        if (paused || Math.abs(c.scrollTop - Math.round(pos[i])) > 2) pos[i] = c.scrollTop;
      }, { passive: true });
    });

    var last = performance.now();
    (function step(now) {
      var dt = Math.min((now - last) / 1000, 0.08);
      last = now;
      if (!paused) {
        cols.forEach(function (c, i) {
          var half = c.scrollHeight / 2;   // each track holds the cards twice
          if (half < 40) return;
          var track = c.firstElementChild;
          var speed = Number(track && track.dataset.speed) || 20;
          var p = pos[i] + speed * dt;
          if (p >= half) p -= half;
          pos[i] = p;
          c.scrollTop = Math.round(p);
        });
      }
      requestAnimationFrame(step);
    })(last);
  }

  /* ------------------------------------------------------------- chart --- */
  function startChartReveal() {
    var chart = $('.mo-chart');
    if (!chart) return;
    if (!('IntersectionObserver' in window)) { chart.classList.add('is-in'); return; }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.35 });
    obs.observe(chart);
  }

  /* --------------------------------------------------------------- init -- */
  renderHero();
  startHeroTimer();
  renderGallery();
  if (MIX) buildMix();
  renderPricing();
  onScroll();
  startReviewWall();
  startChartReveal();
})();

/* Copy/save protection: no context menu or drag on media, no copy of page text. */
(function () {
  var root = document.querySelector('.mo-listicle');
  if (!root) return;
  root.addEventListener('contextmenu', function (e) {
    if (e.target.closest('img, video')) e.preventDefault();
  });
  root.addEventListener('dragstart', function (e) {
    if (e.target.closest('img, video, a')) e.preventDefault();
  });
  root.addEventListener('copy', function (e) { e.preventDefault(); });
})();


/* 11.11 countdown: every [data-s11-cd] counts down to 12 Nov 00:00 SGT */
(function () {
  if (!document.documentElement.classList.contains('is-1111')) return;
  var end = Date.UTC(2026, 10, 11, 16);
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tick() {
    var s = Math.max(0, Math.floor((end - Date.now()) / 1000));
    var d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60);
    var txt = (d ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s % 60);
    var els = document.querySelectorAll('[data-s11-cd]');
    for (var i = 0; i < els.length; i++) els[i].textContent = txt;
  }
  tick();
  setInterval(tick, 1000);
})();
